import type { LifeEvent } from '../../types/onelife.ts';

export const ADOLESCENCE_EVENTS: LifeEvent[] = [
  {
    "id": "ad_01_puberty_growth",
    "stageKey": "adolescence",
    "age": 13,
    "titleVi": "Bước Vào Tuổi Dậy Thì",
    "descriptionVi": "Cơ thể bạn phát triển vượt bậc với chiều cao tăng vọt và giọng nói bắt đầu trầm ấm hơn.",
    "category": "health",
    "choices": [
      {
        "id": "ad_01_a",
        "textVi": "Tập xà đơn, chơi bóng rổ và ăn uống đủ chất",
        "outcomeTextVi": "Bạn có vóc dáng cao ráo, khỏe khoắn và năng động tràn đầy sức sống.",
        "healthDelta": 15,
        "happinessDelta": 15,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "ad_01_b",
        "textVi": "Hơi rụt rè, thích ngồi trong phòng đọc sách truyện",
        "outcomeTextVi": "Tâm hồn bạn trở nên trầm tĩnh, giàu suy tư và nhạy cảm.",
        "healthDelta": 5,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ad_02_confirmation_sacrament",
    "stageKey": "adolescence",
    "age": 14,
    "titleVi": "Bí Tích Thêm Sức & Trưởng Thành Đức Tin",
    "descriptionVi": "Đức Giám Mục về thăm giáo xứ đặt tay ban ơn Chúa Thánh Thần trong Bí Tích Thêm Sức cho giới trẻ.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ad_02_a",
        "textVi": "Sốt sắng lãnh nhận Bí Tích Thêm Sức, sẵn sàng làm chứng nhân Tin Mừng",
        "outcomeTextVi": "Ơn Bảy Ơn Chúa Thánh Thần soi sáng tâm trí, bạn xác tín đức tin vững vàng giữa cuộc đời.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addSacrament": "Bí Tích Thêm Sức",
        "addVirtue": "Lãnh nhận Bí Tích Thêm Sức và kiên vững làm chứng nhân cho tình yêu Thiên Chúa"
      },
      {
        "id": "ad_02_b",
        "textVi": "Cùng ban Huynh Trưởng tham gia nhóm linh hoạt viên giáo lý",
        "outcomeTextVi": "Bạn trở thành hạt nhân tích cực dìu dắt các em thiếu nhi trong xứ.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addSacrament": "Bí Tích Thêm Sức"
      }
    ]
  },
  {
    "id": "ad_03_first_crush",
    "stageKey": "adolescence",
    "age": 15,
    "titleVi": "Rung Động Đầu Đời",
    "descriptionVi": "Một buổi chiều tan trường dưới hàng hiên che mưa, ánh mắt của người bạn cùng lớp khiến tim bạn đập rộn ràng.",
    "category": "love",
    "choices": [
      {
        "id": "ad_03_a",
        "textVi": "Viết bức thư tay nắn nót kẹp vào trang sách trao tặng",
        "outcomeTextVi": "Kỷ niệm học trò trong veo, cả hai cùng hẹn ước phấn đấu thi đỗ trường chuyên.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "unlockRelationship": "Mối Tình Đầu Trong Sáng"
      },
      {
        "id": "ad_03_b",
        "textVi": "Giữ kín tâm tình trong trang nhật ký riêng tư",
        "outcomeTextVi": "Tình cảm thầm lặng trở thành động lực đẹp đẽ để bạn rèn luyện bản thân.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ad_04_high_school_exam",
    "stageKey": "adolescence",
    "age": 15,
    "titleVi": "Kỳ Thi Tuyển Sinh Vào Lớp 10",
    "descriptionVi": "Áp lực ôn thi chuyển cấp đè nặng lên vai với 3 môn thi căng thẳng: Toán, Văn và Ngoại ngữ.",
    "category": "education",
    "choices": [
      {
        "id": "ad_04_a",
        "textVi": "Lập thời gian biểu khoa học, ôn tập nghiêm túc từng chuyên đề",
        "outcomeTextVi": "Bạn thi đỗ vào trường THPT trọng điểm với số điểm cao ngất ngưởng.",
        "healthDelta": -5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 15,
        "unlockEducation": "Trường THPT Trọng Điểm"
      },
      {
        "id": "ad_04_b",
        "textVi": "Vừa học vừa giúp gia đình buôn bán ngoài giờ",
        "outcomeTextVi": "Bạn đỗ vào trường công lập gần nhà, sớm thạo việc kiếm tiền mưu sinh.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 15,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "unlockEducation": "THPT Công Lập Cơ Bản"
      }
    ]
  },
  {
    "id": "ad_05_coding_club",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Câu Lạc Bộ Tin Học & Lập Trình",
    "descriptionVi": "Nhà trường trang bị phòng máy tính mới, câu lạc bộ lập trình phần mềm ra đời.",
    "category": "education",
    "choices": [
      {
        "id": "ad_05_a",
        "textVi": "Say mê viết những dòng code đầu tiên tạo trò chơi mini",
        "outcomeTextVi": "Bạn nhận ra đam mê công nghệ thông tin có thể định hình cả tương lai.",
        "healthDelta": -5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 10,
        "careerTag": "Lập Trình Viên Triển Vọng"
      },
      {
        "id": "ad_05_b",
        "textVi": "Học thiết kế đồ họa vi tính và làm báo tường điện tử",
        "outcomeTextVi": "Bạn có gu thẩm mỹ sắc sảo, phụ trách truyền thông cho các phong trào trường.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_06_part_time_job",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Công Việc Làm Thêm Đầu Đời",
    "descriptionVi": "Kỳ nghỉ hè lớp 11, bạn xin đi phụ quán cà phê hoặc giao báo vào buổi sáng sớm.",
    "category": "career",
    "choices": [
      {
        "id": "ad_06_a",
        "textVi": "Chăm chỉ làm việc, học cách giao tiếp khéo léo với khách hàng",
        "outcomeTextVi": "Tháng lương đầu tiên được bạn mua tặng bố mẹ một giỏ quà ấm áp.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 20,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addVirtue": "Tự lập kiếm tiền chân chính từ thời niên thiếu"
      },
      {
        "id": "ad_06_b",
        "textVi": "Tiết kiệm toàn bộ tiền lương để mua một chiếc máy tính cũ học tập",
        "outcomeTextVi": "Chiếc máy tính trở thành bệ phóng cho nhiều dự án tương lai.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 10,
        "intellectDelta": 20,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ad_07_youth_retreat",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Khóa Tĩnh Tâm Giới Trẻ Mùa Chay",
    "descriptionVi": "Giáo hạt tổ chức 3 ngày tĩnh tâm chuyên đề: \"Tuổi trẻ, lý tưởng sống và Bí Tích Hòa Giải\".",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ad_07_a",
        "textVi": "Dành những giờ thinh lặng cầu nguyện và lãnh nhận Bí Tích Hòa Giải",
        "outcomeTextVi": "Bạn tìm lại sự thanh thản nội tâm, chữa lành những vết thương bồng bột tuổi trẻ.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addSacrament": "Bí Tích Hòa Giải",
        "addVirtue": "Thinh lặng nội tâm và lắng nghe tiếng Chúa gọi nơi sâu thẳm tâm hồn"
      },
      {
        "id": "ad_07_b",
        "textVi": "Cùng nhóm bạn thảo luận về trách nhiệm của người trẻ Công giáo trong xã hội hiện đại",
        "outcomeTextVi": "Những góc nhìn sâu sắc củng cố lý tưởng cống hiến cho công ích của bạn.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "ad_08_rebellion",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Khủng Hoảng Bất Đồng Ý Kiến Cha Mẹ",
    "descriptionVi": "Cha mẹ muốn bạn theo ngành sư phạm hoặc tài chính, trong khi bạn say mê nghệ thuật/kỹ thuật.",
    "category": "family",
    "choices": [
      {
        "id": "ad_08_a",
        "textVi": "Bình tĩnh ngồi xuống trò chuyện, trình bày kế hoạch nghiêm túc và dẫn chứng cụ thể",
        "outcomeTextVi": "Cha mẹ nhìn thấy sự chững chạc của bạn và tôn trọng nguyện vọng.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      },
      {
        "id": "ad_08_b",
        "textVi": "Âm thầm chứng minh bằng thành tích giải thưởng thực tế trước khi thuyết phục",
        "outcomeTextVi": "Thành quả đạt được đập tan mọi nghi ngờ của gia đình.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ad_09_sports_tournament",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Hội Khỏe Phù Đổng Cấp Tỉnh",
    "descriptionVi": "Bạn đại diện cho trường tham gia thi đấu điền kinh cự ly 1.500m hoặc bóng bàn.",
    "category": "health",
    "choices": [
      {
        "id": "ad_09_a",
        "textVi": "Dốc toàn lực bứt tốc ở 100m cuối cùng",
        "outcomeTextVi": "Huy chương Bạc cấp tỉnh và tấm bằng khen danh dự làm rạng danh trường.",
        "healthDelta": 20,
        "happinessDelta": 25,
        "wealthDelta": 5,
        "intellectDelta": 5,
        "relationsDelta": 20
      },
      {
        "id": "ad_09_b",
        "textVi": "Thi đấu fair-play, đỡ đối thủ bị chuột rút dậy cùng về đích",
        "outcomeTextVi": "Hành động nghĩa hiệp được toàn thể khán đài đứng dậy vỗ tay vang dội.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30,
        "addVirtue": "Tinh thần thể thao cao thượng và lòng nhân ái với đối thủ"
      }
    ]
  },
  {
    "id": "ad_10_volunteer_green",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Chiến Dịch Hoa Phượng Đỏ Tình Nguyện",
    "descriptionVi": "Đoàn trường phát động chiến dịch hè dọn rác bãi biển và thăm hỏi các cụ già neo đơn.",
    "category": "society",
    "choices": [
      {
        "id": "ad_10_a",
        "textVi": "Trực tiếp đến trung tâm bảo trợ chăm sóc và đọc báo cho các cụ già",
        "outcomeTextVi": "Những cái nắm tay ấm áp bồi đắp lòng trắc ẩn sâu sắc trong tim bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addVirtue": "Tận tụy thăm viếng và an ủi người già yếu, đơn côi"
      },
      {
        "id": "ad_10_b",
        "textVi": "Tổ chức đội ngũ phân loại rác tái chế gây quỹ học bổng cho học sinh nghèo",
        "outcomeTextVi": "Sáng kiến thành công, trao được 10 suất học bổng vượt khó.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_11_motorcycle_license",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Thi Bằng Lái Xe Máy & Trách Nhiệm Giao Thông",
    "descriptionVi": "Tròn 18 tuổi, bạn đăng ký thi giấy phép lái xe A1 để tự lập đi lại.",
    "category": "society",
    "choices": [
      {
        "id": "ad_11_a",
        "textVi": "Học kỹ luật giao thông, thi lý thuyết tuyệt đối 25/25",
        "outcomeTextVi": "Bạn nhận bằng lái với ý thức tuân thủ pháp luật nghiêm minh, an toàn trên mọi nẻo đường.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "ad_11_b",
        "textVi": "Mua mũ bảo hiểm chuẩn chất lượng cao bảo vệ bản thân và người thân",
        "outcomeTextVi": "Tác phong cẩn trọng giúp bạn luôn an toàn trước mọi hiểm nguy trên đường phố.",
        "healthDelta": 10,
        "happinessDelta": 10,
        "wealthDelta": -10,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ad_12_national_exam",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Kỳ Thi Tốt Nghiệp THPT & Tuyển Sinh Đại Học",
    "descriptionVi": "12 năm đèn sách kết tinh trong kỳ thi quyết định hướng đi tương lai của cuộc đời.",
    "category": "education",
    "choices": [
      {
        "id": "ad_12_a",
        "textVi": "Bình tĩnh làm bài thi đại học khối tự nhiên/kỹ thuật với phong độ cao nhất",
        "outcomeTextVi": "Bạn đạt 27 điểm, trúng tuyển nguyện vọng 1 vào trường Đại học Bách Khoa danh tiếng.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 20,
        "unlockEducation": "Đại Học Danh Tiếng Khối Kỹ Thuật"
      },
      {
        "id": "ad_12_b",
        "textVi": "Nộp hồ sơ khối Kinh tế & Ngoại thương theo đuổi khát vọng thương trường",
        "outcomeTextVi": "Bạn trúng tuyển xuất sắc, mở ra cơ hội hội nhập quốc tế.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 20,
        "unlockEducation": "Đại Học Kinh Tế & Thương Mại"
      },
      {
        "id": "ad_12_c",
        "textVi": "Chọn con đường học nghề chất lượng cao để sớm đi làm hỗ trợ kinh tế gia đình",
        "outcomeTextVi": "Quyết định thực tế giúp bạn nhanh chóng có tay nghề vững và thu nhập ổn định.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 25,
        "intellectDelta": 15,
        "relationsDelta": 15,
        "unlockEducation": "Cao Đẳng Nghề Chuyên Sâu"
      }
    ]
  },
  {
    "id": "ad_13_grandpa_funeral",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Nỗi Đau Mất Đi Người Thân Yêu",
    "descriptionVi": "Ông nội/ngoại qua đời sau cơn bạo bệnh. Lần đầu tiên bạn chứng kiến sự sinh tử mong manh của kiếp người.",
    "category": "family",
    "choices": [
      {
        "id": "ad_13_a",
        "textVi": "Cùng gia đình túc trực bên linh cữu, đọc kinh cầu nguyện cho linh hồn ông",
        "outcomeTextVi": "Lời cầu nguyện nâng đỡ tâm hồn bạn, giúp bạn thấu hiểu ý nghĩa của chữ Hiếu và cõi đời đời.",
        "healthDelta": -5,
        "happinessDelta": -10,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Hiếu nghĩa vẹn toàn, ghi lòng tạc dạ công ơn đấng sinh thành"
      },
      {
        "id": "ad_13_b",
        "textVi": "Gắng nén đau thương, chăm sóc bố mẹ đang suy sụp sức khỏe",
        "outcomeTextVi": "Bạn trở thành điểm tựa vững chãi cho cả nhà trong giai đoạn đau thương.",
        "healthDelta": 0,
        "happinessDelta": -5,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "ad_14_music_band",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Ban Nhạc Học Sinh Acoustic",
    "descriptionVi": "Bạn cùng các bạn cùng lớp thành lập một ban nhạc acoustic chơi đàn guitar và hát mộc.",
    "category": "education",
    "choices": [
      {
        "id": "ad_14_a",
        "textVi": "Làm cây guitar chính, biểu diễn tại quán trà cúc gây quỹ từ thiện",
        "outcomeTextVi": "Tiếng đàn lãng tử mang lại nhiều người bạn mới và kỷ niệm khó quên.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 5,
        "intellectDelta": 10,
        "relationsDelta": 25
      },
      {
        "id": "ad_14_b",
        "textVi": "Sáng tác một ca khúc về tuổi học trò và mái trường thân yêu",
        "outcomeTextVi": "Bài hát được toàn trường hát vang trong ngày lễ ra trường.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_15_peer_pressure",
    "stageKey": "adolescence",
    "age": 15,
    "titleVi": "Cám Dỗ Rủ Rê Thuốc Lá & Đua Xe",
    "descriptionVi": "Nhóm bạn chơi ngoài phố rủ bạn thử hút thuốc và tham gia tụ tập chạy xe lạng lách ban đêm.",
    "category": "health",
    "choices": [
      {
        "id": "ad_15_a",
        "textVi": "Dứt khoát từ chối và khuyên can bạn bè không nên sa đà",
        "outcomeTextVi": "Bạn giữ vững nhân cách trong sạch và không bị cuốn vào tệ nạn xã hội.",
        "healthDelta": 10,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 5,
        "addVirtue": "Bản lĩnh cương quyết nói không trước cám dỗ tệ nạn"
      },
      {
        "id": "ad_15_b",
        "textVi": "Tìm cớ khéo léo rút lui và chuyển sang kết bạn với nhóm bạn học chăm chỉ",
        "outcomeTextVi": "Môi trường sống lành mạnh giúp bạn tập trung toàn lực vào tương lai.",
        "healthDelta": 10,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ad_16_vocational_discernment",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Phân Định Ơn Gọi Tu Trì Hoặc Đời Sống Gia Đình",
    "descriptionVi": "Trong những giờ chầu Thánh Thể trang nghiêm, bạn suy ngẫm về tiếng gọi dâng hiến hoặc đời sống hôn nhân tương lai.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ad_16_a",
        "textVi": "Tham gia tuần tìm hiểu ơn gọi tại Đại Chủng Viện hoặc Dòng Tu",
        "outcomeTextVi": "Bạn trải nghiệm đời sống cầu nguyện sâu lắng, hiểu rõ thánh ý Chúa dành cho mình.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 15,
        "addVirtue": "Thành tâm kiếm tìm và vâng nghe thánh ý Thiên Chúa"
      },
      {
        "id": "ad_16_b",
        "textVi": "Xác định theo đuổi ơn gọi gia đình, cầu xin Chúa ban một người bạn đời đạo hạnh",
        "outcomeTextVi": "Bạn nuôi dưỡng ước mơ xây dựng một tổ ấm Công giáo gương mẫu.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_17_english_speaking",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Hùng Biện Tiếng Anh Cấp Thành Phố",
    "descriptionVi": "Cuộc thi hùng biện tiếng Anh chủ đề \"Thanh niên với Mục tiêu Phát triển Bền vững\".",
    "category": "education",
    "choices": [
      {
        "id": "ad_17_a",
        "textVi": "Tự tin thuyết trình bằng tiếng Anh lưu loát với lập luận sắc bén",
        "outcomeTextVi": "Bạn đoạt giải Nhất và nhận suất học bổng ngoại ngữ toàn phần.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 30,
        "relationsDelta": 15,
        "unlockAchievement": "Nhà Hùng Biện Trẻ"
      },
      {
        "id": "ad_17_b",
        "textVi": "Học hỏi từ bạn bè quốc tế qua các buổi giao lưu văn hóa",
        "outcomeTextVi": "Tầm nhìn thế giới của bạn được mở rộng vượt bậc.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "ad_18_family_financial_crisis",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Biến Cố Kinh Tế Gia Đình Khó Khăn",
    "descriptionVi": "Việc làm ăn của cha mẹ gặp trắc trở vì dịch bệnh hoặc nợ nần, ngân quỹ gia đình eo hẹp.",
    "category": "family",
    "choices": [
      {
        "id": "ad_18_a",
        "textVi": "Cắt giảm tối đa chi tiêu cá nhân, nhận dạy kèm kiếm tiền phụ sinh hoạt phí",
        "outcomeTextVi": "Sự hiểu chuyện của bạn giúp cha mẹ vơi bớt gánh nặng lo toan.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 15,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addVirtue": "Cùng gia đình chia ngọt sẻ bùi qua cơn bĩ cực"
      },
      {
        "id": "ad_18_b",
        "textVi": "Tìm học bổng trợ cấp khó khăn của trường để tiếp tục con đường học tập",
        "outcomeTextVi": "Bạn được nhà trường trao học bổng vượt khó hiếu học kịp thời.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 10,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ad_19_martial_arts",
    "stageKey": "adolescence",
    "age": 14,
    "titleVi": "Học Võ Vovinam / Taekwondo Tự Vệ",
    "descriptionVi": "CLB võ thuật mở lớp rèn luyện thể lực và đạo đức võ đạo cho thanh thiếu niên.",
    "category": "health",
    "choices": [
      {
        "id": "ad_19_a",
        "textVi": "Chăm chỉ luyện các bài quyền và đòn chân tấn công",
        "outcomeTextVi": "Bạn đạt đai lam/đai đỏ, thể lực sung mãn và có khả năng tự vệ tự tin.",
        "healthDelta": 20,
        "happinessDelta": 15,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 10
      },
      {
        "id": "ad_19_b",
        "textVi": "Thấm nhuần tinh thần võ đạo: dùng võ để giúp đời, không kiêu căng",
        "outcomeTextVi": "Đức tính khiêm nhường võ hiệp được thầy cô và bạn đồng môn kính trọng.",
        "healthDelta": 15,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addVirtue": "Tinh thần thượng võ và đạo đức khiêm nhường"
      }
    ]
  },
  {
    "id": "ad_20_camping_trekking",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Chuyến Leo Núi Chinh Phục Đỉnh Cao",
    "descriptionVi": "Nhóm bạn cùng leo đỉnh núi Phan Xi Păng hoặc đỉnh Bà Đen mừng sinh nhật tuổi 18.",
    "category": "health",
    "choices": [
      {
        "id": "ad_20_a",
        "textVi": "Vượt qua những con dốc đá hiểm trở để đón bình minh trên đỉnh núi",
        "outcomeTextVi": "Đứng giữa biển mây bồng bềnh, bạn cảm nhận sức mạnh ý chí vô biên của tuổi trẻ.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 20
      },
      {
        "id": "ad_20_b",
        "textVi": "Luôn đi sau hỗ trợ các bạn kiệt sức, chia sẻ nước uống và lương khô",
        "outcomeTextVi": "Bạn trở thành người dẫn đường tin cậy của toàn đoàn leo núi.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "ad_21_charity_caritas",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Nồi Cháo Tình Thương Bệnh Viện",
    "descriptionVi": "Ban Bác Ái Caritas tổ chức nấu cháo miễn phí phát cho bệnh nhân nghèo vào sáng thứ Bảy.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ad_21_a",
        "textVi": "Dậy từ 4 giờ sáng thổi lửa nấu cháo và tận tay trao từng bát cháo nóng",
        "outcomeTextVi": "Nụ cười và ánh mắt biết ơn của những người bệnh nghèo làm ấm sáng cả ngày của bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 25,
        "addVirtue": "Thực thi đức ái cụ thể qua việc phục vụ người nghèo khó và bệnh tật"
      },
      {
        "id": "ad_21_b",
        "textVi": "Vận động bạn bè cùng lớp quyên góp gạo và sữa cho bệnh nhi ung thư",
        "outcomeTextVi": "Lan tỏa ngọn lửa bác ái đến bạn bè xung quanh một cách mạnh mẽ.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "ad_22_history_heritage",
    "stageKey": "adolescence",
    "age": 15,
    "titleVi": "Chuyến Tham Quan Di Tích Cố Đô",
    "descriptionVi": "Chuyến điền dã lịch sử về thăm Cố đô Hoa Lư, đền Vua Đinh Vua Lê và Hoàng thành Thăng Long.",
    "category": "education",
    "choices": [
      {
        "id": "ad_22_a",
        "textVi": "Chăm chú ghi chép bia đá, tìm hiểu nguồn cội ngàn năm văn hiến",
        "outcomeTextVi": "Lòng tự hào dân tộc và tình yêu giang sơn đất nước bừng sáng trong tâm can.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 20,
        "relationsDelta": 15
      },
      {
        "id": "ad_22_b",
        "textVi": "Làm phim ngắn giới thiệu vẻ đẹp di sản văn hóa truyền thống",
        "outcomeTextVi": "Tác phẩm đạt giải cao trong cuộc thi truyền thông trẻ của tỉnh.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_23_chess_championship",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Giải Vô Địch Cờ Tướng / Cờ Vua Trẻ",
    "descriptionVi": "Sau nhiều năm rèn luyện, bạn đại diện cho cụm trường tham gia tranh chức Kỳ Vương trẻ tuổi.",
    "category": "education",
    "choices": [
      {
        "id": "ad_23_a",
        "textVi": "Dùng đòn song pháo kẹp cổ hạ gục đại diện kỳ viện trong trận chung kết",
        "outcomeTextVi": "Bạn đăng quang chức vô địch kỳ thủ trẻ với phong thái đĩnh đạc, mưu lược.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": 10,
        "intellectDelta": 30,
        "relationsDelta": 15,
        "unlockAchievement": "Kỳ Vương Trẻ Tuổi"
      },
      {
        "id": "ad_23_b",
        "textVi": "Gặp đối thủ già dặn kinh nghiệm, kiên cường thủ hòa thành công",
        "outcomeTextVi": "Khả năng phòng ngự kiên cố và tâm lý vững vàng được giới chuyên môn khen ngợi.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 5,
        "intellectDelta": 25,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ad_24_reading_classics",
    "stageKey": "adolescence",
    "age": 17,
    "titleVi": "Đọc Sách Kinh Điển Triết Học & Văn Học",
    "descriptionVi": "Bạn dành nhiều buổi chiều cuối tuần đắm chìm trong các tác phẩm văn học lớn: Truyện Kiều, Những Người Khốn Khổ.",
    "category": "education",
    "choices": [
      {
        "id": "ad_24_a",
        "textVi": "Suy ngẫm về phận người và lòng bao dung độ lượng trong tác phẩm",
        "outcomeTextVi": "Chiều sâu tri thức và lòng nhân ái của bạn đạt tới độ chín muồi.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 10
      },
      {
        "id": "ad_24_b",
        "textVi": "Viết bài luận văn học đạt điểm 9.5 tuyệt đối",
        "outcomeTextVi": "Bài văn được in làm tài liệu tham khảo cho các khóa học sinh kế tiếp.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ad_25_friendship_crisis",
    "stageKey": "adolescence",
    "age": 16,
    "titleVi": "Hiểu Lầm Giữa Bạn Bè Thân Thiết",
    "descriptionVi": "Một tin đồn thất thiệt khiến người bạn thân nhất nghi ngờ và xa lánh bạn suốt một tuần.",
    "category": "relations",
    "choices": [
      {
        "id": "ad_25_a",
        "textVi": "Chủ động gặp mặt đối thoại chân thành, giải thích rõ ràng không giấu giếm",
        "outcomeTextVi": "Bức tường hoài nghi sụp đổ, tình bạn sau giông tố càng thêm bền chặt.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addVirtue": "Chân thành giải tỏa hiểu lầm và trân trọng tình bạn chân chính"
      },
      {
        "id": "ad_25_b",
        "textVi": "Lặng lẽ gửi tặng món quà kỷ niệm cùng bức thư viết tay",
        "outcomeTextVi": "Người bạn xúc động bật khóc xin lỗi vì đã vội vã nghi ngờ bạn.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_26_traffic_accident_witness",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Sơ Cứu Người Bị Nạn Giao Thông",
    "descriptionVi": "Trên đường vắng ban đêm, một người đi xe máy bị ngã bất tỉnh bên lề đường.",
    "category": "society",
    "choices": [
      {
        "id": "ad_26_a",
        "textVi": "Bình tĩnh kiểm tra đường thở, gọi xe cấp cứu 115 và bảo vệ hiện trường",
        "outcomeTextVi": "Nạn nhân được cấp cứu qua cơn nguy kịch, gia đình họ vô cùng biết ơn bạn.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Sẵn sàng cứu giúp người hoạn nạn giữa đêm hôm khuya khoắt"
      },
      {
        "id": "ad_26_b",
        "textVi": "Hô hoán người dân xung quanh cùng hợp lực ứng cứu",
        "outcomeTextVi": "Sự nhanh trí của bạn giúp quy tụ sự giúp đỡ kịp thời của cộng đồng.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_27_farewell_prom",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Lễ Tri Ân & Trưởng Thành Tuổi 18",
    "descriptionVi": "Đêm dạ hội bế giảng THPT rực rỡ ánh sáng, hoa hồng cài áo tri ân công ơn sinh thành.",
    "category": "family",
    "choices": [
      {
        "id": "ad_27_a",
        "textVi": "Cài bông hoa hồng lên ngực áo cha mẹ và nghẹn ngào nói lời cảm ơn",
        "outcomeTextVi": "Giọt nước mắt hạnh phúc của cha mẹ là món quà vô giá của tuổi trưởng thành.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30,
        "addVirtue": "Hiếu nghĩa thâm ân với đấng sinh thành trong ngày trưởng thành"
      },
      {
        "id": "ad_27_b",
        "textVi": "Khiêu vũ điệu waltz đầu đời cùng người bạn thầm mến",
        "outcomeTextVi": "Một khoảnh khắc lãng mạn như cổ tích khép lại thời thanh xuân học trò.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ad_28_leaving_home",
    "stageKey": "adolescence",
    "age": 18,
    "titleVi": "Xếp Hành Lý Rời Quê Bước Ra Thế Giới",
    "descriptionVi": "Chuyến xe khách hoặc tàu hỏa đầu tiên đưa bạn từ làng quê lên thành phố lớn bắt đầu cuộc đời sinh viên/lập nghiệp.",
    "category": "society",
    "choices": [
      {
        "id": "ad_28_a",
        "textVi": "Hít một hơi thật sâu, vẫy tay chào cha mẹ với ánh mắt kiên định",
        "outcomeTextVi": "Bạn mang theo lời dặn dò của gia đình làm hành trang bước vào biển lớn cuộc đời.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 15,
        "unlockPlacesLived": "Thành Phố Lớn Sầm Uất"
      },
      {
        "id": "ad_28_b",
        "textVi": "Nắm chặt chuỗi hạt Mân Côi cha mẹ trao tặng trước lúc lên đường",
        "outcomeTextVi": "Niềm tin thiêng liêng sưởi ấm tâm hồn bạn những ngày đầu bỡ ngỡ nơi đất khách quê người.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  }
];
